import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import {
  getAreaProductionAndLoss,
  getIrrigationTechniques,
  getWaterSources,
} from '../../../../../services/Elegibilidad/get'
import {
  InsertIrrigationSystemNew,
  insertIrrigationSystem,
} from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import NumberFormat from 'react-number-format'

export const Modal397 = ({
  open,
  setOpen,
  body,
  setBody,
  getDataTable,
  idElegibilityForm,
}) => {
  const [waterSources, setWaterSources] = useState([])
  const [irrigationTechniques, setIrrigationTechniques] = useState([])
  const [areaData, setAreaData] = useState([])
  const [SubProjectHectares, setSubProjectHectares] = useState('')
  const [loading, setLoading] = useState(false)

  const {
    IdIrrigationSystem,
    IdProductionAndLosseByClimate,
    IdWaterSource,
    WaterSource,
    IdIrrigationTechnique,
    IrrigationTechnique,
    PermanentIrrigationArea,
    Area,
    //  SubProjectHectares,
  } = body

  const GeneralDataSchema = Yup.object().shape({
    Area: Yup.string().required('Este campo es obligatorio'),
    IdWaterSource: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),

    IdIrrigationTechnique: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    PermanentIrrigationArea: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .max(
        SubProjectHectares,
        'Área de cultivo no debe ser mayor a la cantidad ingresada en Hectáreas que forman parte del subproyecto ',
      ),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdElegibilityAnswer: idElegibilityForm,
      IdIrrigationSystem: IdIrrigationSystem,
      IdProductionAndLosseByClimate: IdProductionAndLosseByClimate,
      IdWaterSource: IdWaterSource,
      WaterSource: WaterSource,
      IdIrrigationTechnique: IdIrrigationTechnique,
      IrrigationTechnique: IrrigationTechnique,
      PermanentIrrigationArea: PermanentIrrigationArea,
      Area: Area,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar(formik.values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setBody({})
    setSubProjectHectares('')
  }

  const getListWaterSources = async () => {
    try {
      const response = await getWaterSources()

      if (response.Success) setWaterSources(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const getAreaProduction = async () => {
    try {
      const response = await getAreaProductionAndLoss(idElegibilityForm)
      if (response.Success) {
        setAreaData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getListIrrigationTechniques = async () => {
    try {
      const response = await getIrrigationTechniques()
      if (response.Success) setIrrigationTechniques(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (open) {
      getListWaterSources()
      getListIrrigationTechniques()
      getAreaProduction()
    }
  }, [open])
  useEffect(() => {
    if (Object.keys(body).length !== 0 && areaData !== []) {
      const resultArea = areaData.filter(
        (obj) => obj.CategoryProduct === formik.values.Area,
      )
      setSubProjectHectares(resultArea[0]?.SubProjectHectares)
    }
  }, [formik.values.Area, areaData])

  const handleGuardar = async (values) => {
    setLoading(true)
    let response
    if (Object.keys(body).length !== 0) {
      response = await insertIrrigationSystem(values)
    } else {
      response = await InsertIrrigationSystemNew(values)
    }
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      handleClose()
      setLoading(false)
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos del sistema de riego</h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Rubro / Producto</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    value={formik.values.Area}
                    onChange={(e) => {
                      formik.setFieldValue('Area', e.target.value)
                      const resultArea = areaData.filter(
                        (obj) => obj.CategoryProduct === e.target.value,
                      )
                      setSubProjectHectares(resultArea[0].SubProjectHectares)
                    }}
                    error={formik.errors.Area}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                    {areaData &&
                      areaData.map((item, key) => (
                        <MenuItem key={key} value={item.CategoryProduct}>
                          {item.CategoryProduct}
                        </MenuItem>
                      ))}
                  </Select>
                  {formik.errors.Area ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.Area}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Fuente de agua</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    value={formik.values.IdWaterSource}
                    renderValue={
                      formik.values.IdWaterSource !== null
                        ? undefined
                        : () => 'Seleccione una opción'
                    }
                    onChange={(e) => {
                      formik.setFieldValue('IdWaterSource', e.target.value)
                    }}
                    error={formik.errors.IdWaterSource}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                    {waterSources &&
                      waterSources.map((item, key) => (
                        <MenuItem key={key} value={item.IdWaterSource}>
                          {item.Description}
                        </MenuItem>
                      ))}
                  </Select>
                  {formik.errors.IdWaterSource ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.IdWaterSource}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Técnica / Método de riego
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    displayEmpty={true}
                    value={formik.values.IdIrrigationTechnique}
                    renderValue={
                      formik.values.IdIrrigationTechnique !== null
                        ? undefined
                        : () => 'Seleccione una opción'
                    }
                    onChange={(e) => {
                      formik.setFieldValue(
                        'IdIrrigationTechnique',
                        e.target.value,
                      )
                    }}
                    error={formik.errors.IdIrrigationTechnique}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                    {irrigationTechniques &&
                      irrigationTechniques.map((item, key) => (
                        <MenuItem key={key} value={item.IdIrrigationTechnique}>
                          {item.Description}
                        </MenuItem>
                      ))}
                  </Select>
                  {formik.errors.IdIrrigationTechnique ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.IdIrrigationTechnique}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Área de cultivo con riego permanente (Ha)
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <NumberFormat
                    id="PermanentIrrigationArea"
                    name="PermanentIrrigationArea"
                    customInput={TextField}
                    thousandSeparator={true}
                    autoComplete="off"
                    variant="outlined"
                    allowNegative={false}
                    allowLeadingZeros={false}
                    value={formik.values.PermanentIrrigationArea}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'PermanentIrrigationArea',
                        Number(e.target.value.replaceAll(',', '')),
                      )
                    }}
                    inputProps={{ maxLength: 14 }}
                    decimalScale={2}
                    error={formik.errors.PermanentIrrigationArea}
                  />
                  {formik.errors.PermanentIrrigationArea ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.PermanentIrrigationArea}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  disabled={loading}
                  onClick={validateFormStatus}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
